<template>
  <a-button-group v-if="enableVoiceRecognition && browserSupportSpeechRecognition">
    <a-tooltip placemen="auto">
      <template slot="title">
        {{$t('start_voice_recognition')}}
      </template>
      <a-button
        size="large"
        type="primary"
        @click="startRecognition"
        :disabled="disableStartRecognition"
      >
        <i class="mdi mdi-microphone"></i>
      </a-button>
    </a-tooltip>

    <a-tooltip placeent="auto">
      <template slot="title">
        {{$t('stop_voice_recognition')}}
      </template>
      <a-button
        size="large"
        @click="stopRecognition"
        :disabled="disableStopRecognition"
        type="danger"
      >
        <i class="mdi mdi-stop"></i>
      </a-button>
    </a-tooltip>
    <a-button v-if="timer" size="large" loading>
      {{ elapsedTime }} {{$t('seconds')}}
    </a-button>
  </a-button-group>
</template>

<script>
export default {
  props: {
    value: null,
    enableVoiceRecognition: {
      type: Boolean,
      default: false
    },
    voiceRecognitionLanguaje: {
      type: String,
      default: 'es-AR'
    }
  },
  data () {
    return {
      initialText: this.value,
      browserSupportSpeechRecognition: false,
      recognition: null, // Instancia del objeto de reconocimiento de voz
      timer: null, // Referencia para el intervalo del temporizador
      elapsedTime: 0, // Tiempo transcurrido en segundos
      disableStartRecognition: false,
      disableStopRecognition: true,
      textAccumulated: '', // Almacena el texto final acumulado aquí
      currentInterimText: '' // Almacena el texto intermedio actual aquí
    }
  },
  methods: {
    startTimer () {
      this.elapsedTime = 0 // Reiniciar el contador de tiempo
      this.timer = setInterval(() => {
        this.elapsedTime++
      }, 1000) // Incrementar el contador cada segundo
    },
    stopTimer () {
      clearInterval(this.timer) // Detener el temporizador
      this.timer = null // Limpiar la referencia al intervalo
    },
    startRecognition () {
      if (this.recognition) {
        this.disableStartRecognition = true
        this.disableStopRecognition = false
        this.initialText = this.value
        this.textAccumulated = ''
        this.currentInterimText = ''
        this.recognition.start() // Iniciar el reconocimiento de voz
        this.startTimer() // Iniciar el contador de tiempo
      }
    },
    stopRecognition () {
      if (this.recognition) {
        this.recognition.stop() // Detener el reconocimiento de voz
        this.stopTimer() // Detener el contador de tiempo
        this.disableStartRecognition = false
        this.disableStopRecognition = true
      }
    }
  },
  created () {
    // Verificar si el navegador soporta la Web Speech API
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition
    if (SpeechRecognition) {
      this.browserSupportSpeechRecognition = true
      this.recognition = new SpeechRecognition()
      this.recognition.lang = this.voiceRecognitionLanguaje // Configurar el idioma a español de Argentina
      this.recognition.continuous = true // Configurar para que la captura sea continua
      this.recognition.interimResults = true // Obtener resultados parciales

      // Evento para cuando se reconozca el habla
      this.recognition.onresult = (event) => {
        let interimText = ''
        let newText = this.initialText

        for (let i = event.resultIndex; i < event.results.length; ++i) {
          if (event.results[i].isFinal) {
            this.textAccumulated += event.results[i][0].transcript + ' '
          } else {
            interimText += event.results[i][0].transcript
          }
        }

        this.currentInterimText = interimText // Actualiza el texto intermedio actual
        newText += this.textAccumulated + this.currentInterimText
        this.$emit('onVoiceRecognitionResult', newText) // Añadir el texto reconocido al texto existente
      }
    }
  }
}
</script>
